export class UserApi {
    async index() {
        try {
            const response = await axios.get('/adm/users');

            return response.data;
        } catch (error) {
            console.error('Error fetching users:', error);
            throw error;
        }
    }

    async show(id) {
        try {
            // ATENCAO NESSA ROTA
            const response = await axios.get(`/adm/user/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error fetching user:', error);
            throw error;
        }
    }

    async store(data) {
        try {
            const response = await axios.post('/adm/users', data);

            return response.data;
        } catch (error) {
            console.error('Error store user:', error);
            throw error;
        }
    }

    async update(data, id) {
        try {
            const response = await axios.put(`/adm/users/${id}`, data);

            return response.data;
        } catch (error) {
            console.error('Error updating user:', error);
            throw error;
        }
    }

    async roles() {
        try {
            const response = await axios.get('/adm/roles/pluck');

            return response.data;
        } catch (error) {
            console.error('Error fetching roles:', error);
            throw error;
        }
    }

    async pluckRepresenters() {
        try {
            const response = await axios.get('/adm/users/representantes/pluck');

            return response.data;
        } catch (error) {
            console.error('Error fetching representers:', error);
            throw error;
        }
    }
    
    async updatePassword(data, id) {
        try {
            const response = await axios.patch(`/adm/users/${id}`, data);

            return response.data;
        } catch (error) {
            console.error('Error updating user:', error);
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/User/UserApi.js